import React from 'react';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';
import {AntiRaidFeature} from '../../../assets';

export const AntiRaid = () => {
  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Anti-Raid"
        subTitle="The bot prevents bot raids by employing a flexible, AI-like algorithm that works around the clock to prevent bot raids on your server, automatically mitigating raid threats through mass banning. The algorithm's flexibility and accuracy prevent real users from being blocked. Furthermore, the algorithm is improved regularly by analysing the various exclusive and private software abusers use."
        labelTitle="Anti-Raid Tutorial"
        labelLInk={featuresLinks.antiRaid}
      />
      <div className={styles.block}>
        <div className={styles.image}>
          <AntiRaidFeature />
        </div>
      </div>
    </div>
  );
};
